<div class="d-flex justify-content-center align-items-center w-100 h-100">
    <p class="mb-0">Retrieving user data...</p>
</div>
